export default "__VITE_ASSET__0004ed21__"